import { render, staticRenderFns } from "./ProductReviewModal.vue?vue&type=template&id=6d6e6740&scoped=true&"
import script from "./ProductReviewModal.vue?vue&type=script&lang=js&"
export * from "./ProductReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductReviewModal.vue?vue&type=style&index=0&id=6d6e6740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e6740",
  null
  
)

export default component.exports